import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ReimbursementService {
  isRoutrToTask: boolean = false;
  routerData:any={}
  httpUrl;
  routeAction:any;
  routeOrigin:any;
  constructor(private http: HttpClient, private main: MainService,private spinner:NgxSpinnerService) {
    this.httpUrl = this.main.httpUrl + '/accounts';
  }

  async getAllReimbursement(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/reimbursement/getAllReimbursement' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getAllReimbursementEventCode(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/reimbursement/getEventCodeReimburs' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }


  async addReimbursement(obj:any) {
    const resp = await this.http.post<any>(this.httpUrl + '/reimbursement/addReimbursement' , obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async updateReimbursement(obj:any) {
    const resp = await this.http.post<any>(this.httpUrl + '/reimbursement/updateReimbursement', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }


  async deleteReimbursement(obj:any) {
    const resp = await this.http.delete<any>(this.httpUrl + '/reimbursement/deleteReimbursement' + JSON.stringify(obj)).toPromise().then(res => {
      return res;
    });
    return resp;
  }


  async requestReimbursement(obj:any) {
    const resp = await this.http.post<any>(this.httpUrl  + '/reimbursement/requestReimbursement' , obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  
  async get_document(obj:any) {
    const resp = await this.http.post(this.httpUrl + '/reimbursement/get_document', obj, { responseType: 'blob' }).toPromise().then(res => {
      // try {
      //   return res;
      // } catch (error) {
      //   return error
      // }
      return res;
    });
    // if (resp) {
      return resp;
    // }
  }



  async getPOandReimbursement(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/reimbursement/reimbusementAndPODtl' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getNotesheet(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/reimbursement/getNotesheet' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }






  async viewDocument(obj:any) {
    this.spinner.show()
    let res = await this.get_document(obj)
    try {
      if (res) {
        if (res.type != "application/pdf") {
          Swal.fire('INFO', 'Document Not Uploaded', 'info')
          this.spinner.hide()
          return;
        }
        let file = new Blob([res], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    } catch (error) {
      this.spinner.hide();
      Swal.fire('Error', `Can't fetch at the moment. Please try again later`, 'error')
    }
  }

}
